module.exports = __webpack_public_path__ + "img/circle_people_meeting_128x128.a58b90f0.png";